import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import urlJoin from 'url-join';
import { widont } from 'typogr';
import { getImageByWidth } from '../../utils/api';
import CtaButton from '../CtaButton';


class GridCoverItem extends Component {
  constructor (props) {
    super(props);
    this.state = {
      nextUrl: null,
      isActive: false,
      isArmed: false,
    };

    this.titleUrls = props.sections.navItems.reduce((result, slug, i) => {
      props.sections.bySlug[slug].items.forEach((item, itemIndex) => {
        const sectionBasePath = `/${i + 1}/${slug}`;
        const url = itemIndex > 0 ? urlJoin(sectionBasePath, item.urlSlug) : sectionBasePath;
        result[item.uid] = url;
      });
      return result;
    }, {});

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentDidUpdate (prevProps, prevState) {
    const { activeItemId, uid } = this.props;
    if (activeItemId !== prevProps.activeItemId && activeItemId !== uid) {
      this.setState({ isActive: false });
    }
  }

  handleMouseEnter () {
    const { breakpoint } = this.props;
    if (!breakpoint.lessThan.lg) {
      this.activate();
    }
  }

  handleMouseLeave () {
    const { breakpoint } = this.props;
    if (!breakpoint.lessThan.lg) {
      this.setState({ isActive: false });
    }
  }

  handleClick (uid) {
    const { breakpoint } = this.props;
    const { isActive } = this.state;
    if (breakpoint.lessThan.lg && !isActive) {
      this.activate();
    } else {
      this.navigateToTarget(uid);
    }
  }

  activate () {
    const { onActivate } = this.props;
    this.setState({ isActive: true });
    onActivate && onActivate(this.node);
  }

  navigateToTarget (uid) {
    const { history } = this.props;
    const nextUrl = this.titleUrls[uid];
    history.push(nextUrl);
  }

  render () {
    const { name, description, image, linkType, titleId, mediaId, buttonText } = this.props;
    const { isActive } = this.state;
    const imageVersion = getImageByWidth(image.versions, 900);
    const style = {};
    if (imageVersion) {
      style.backgroundImage = `url('${imageVersion.url}')`;
    }

    const itemId = linkType === 'media' ? mediaId : titleId;

    return (
      <div ref={node => this.node = node} className={classNames('grid-cover-item', isActive && 'active')}>
        <div
          className="grid-cover-item-inner"
          style={style}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={() => this.handleClick(itemId)}
        >
          <div className="grid-cover-item-overlay" />
          <div className="grid-cover-item-label">{name}</div>
          <div className="grid-cover-item-content">
            <div className="text">
              <h4>{name}</h4>
              <div className="body-copy description" dangerouslySetInnerHTML={{ __html: widont(description) }} />
            </div>
            <div className="button">
              <CtaButton small text={buttonText} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GridCoverItem.propTypes = {
  history: PropTypes.object,
  uid: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  buttonText: PropTypes.string,
  linkType: PropTypes.oneOf(['title', 'media']),
  titleId: PropTypes.string,
  mediaId: PropTypes.string,
  activeItemId: PropTypes.string,
  onActivate: PropTypes.func,
};

const mapStateToProps = ({ breakpoint, ui, sections }) => ({ breakpoint, ui, sections });

export default withRouter(connect(mapStateToProps)(GridCoverItem));



// WEBPACK FOOTER //
// ./src/components/GridCover/GridCoverItem.js